import clone from 'lodash/cloneDeep';
import initialState from '../../../store/initialState';
import {
  UPDATE_AUDIT_DATA_STARTING,
  UPDATE_AUDIT_DATA_SUCCESS,
  UPDATE_AUDIT_DATA_ERROR,
} from '../../../constants/actionTypes';

export default function updateAuditReducer(state = initialState.updateAudit, action) {
  switch (action.type) {
    case UPDATE_AUDIT_DATA_STARTING: {
      const { auditId } = action;
      const newState = clone(state);

      if (!newState[auditId]) {
        newState[auditId] = clone(initialState.updateAudit.auditId);
      }

      const updateData = newState[auditId];
      updateData.saving = true;
      updateData.saved = false;
      updateData.error = null;

      return newState;
    }

    case UPDATE_AUDIT_DATA_SUCCESS: {
      const { auditId } = action;
      const newState = clone(state);

      if (!newState[auditId]) {
        newState[auditId] = clone(initialState.updateAudit.auditId);
      }

      const updateData = newState[auditId];
      updateData.saving = false;
      updateData.saved = true;
      updateData.error = null;
      return newState;
    }

    case UPDATE_AUDIT_DATA_ERROR: {
      const { auditId } = action;
      const newState = clone(state);

      if (!newState[auditId]) {
        newState[auditId] = clone(initialState.updateAudit.auditId);
      }

      const updateData = newState[auditId];
      updateData.saving = false;
      updateData.saved = false;
      updateData.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
